import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Best Vocal Cord Treatment & Surgery Cost in Delhi, India |Doctor, Clinic</title>
            <meta name="description" content="Get precise Vocal Cord Surgery in Delhi, India. Learn about treatment procedure, recovery, and surgery cost from experienced ENT specialists." />
            <meta name="keywords" content="vocal cord surgery Delhi, voice treatment, ENT vocal specialist, hoarseness treatment" />
            <link rel="canonical" href="" />
            <meta property="og:title" content="Best Vocal Cord Treatment & Surgery Cost in Delhi, India |Doctor, Clinic" />
            <meta property="og:description" content="Get precise Vocal Cord Surgery in Delhi, India. Learn about treatment procedure, recovery, and surgery cost from experienced ENT specialists." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
